module.exports = __webpack_public_path__ + "img/echope_horizontal_large.12ba0dfe.png";